import axios from 'axios';
import authHeader from './authHeader';

const API_URL = '/api/bins/';

const getAllBins = async () => {
  const response = await axios.get(API_URL, { headers: authHeader() });
  return response.data;
};

const getBinById = async (id, options = {}) => {
  const params = {};
  if (options && options.range) params.range = options.range;
  if (options && options.metric) params.metric = options.metric;
  if (options && options.detailsOnly) params.detailsOnly = 'true';
  const response = await axios.get(API_URL + id, { headers: authHeader(), params });
  return response.data;
};

const getBinTelemetry = async (id, options = {}) => {
  const params = {};
  if (options && options.range) params.range = options.range;
  if (options && options.metric) params.metric = options.metric;
  const response = await axios.get(API_URL + id + '/telemetry', { headers: authHeader(), params });
  return response.data;
};

const createBin = async (binData) => {
    const response = await axios.post(API_URL, binData, { headers: authHeader() });
    return response.data;
};

const sendCommand = async (id, command, payload) => {
    const response = await axios.post(API_URL + id + '/command', { command, payload }, { headers: authHeader() });
    return response.data;
};

// Convenience: latch open/close
const setLatch = async (id, open) => {
  const response = await axios.post(API_URL + id + '/command', { command: 'latch', payload: { open: !!open } }, { headers: authHeader() });
  return response.data;
};

// Update bin (admin only). binData may include bin_identifier, site_id, address, latitude, longitude
const updateBin = async (id, binData) => {
  const response = await axios.put(API_URL + id, binData, { headers: authHeader() });
  return response.data;
};

// Soft delete (admin only)
const deleteBin = async (id) => {
  const response = await axios.delete(API_URL + id, { headers: authHeader() });
  return response.data;
};

// Restore soft-deleted bin (admin only)
const restoreBin = async (id) => {
  const response = await axios.post(API_URL + id + '/restore', {}, { headers: authHeader() });
  return response.data;
};

// Batch update ordering (admin only): { site_id, ordered_bin_ids: [] }
const updateOrder = async (siteId, orderedBinIds) => {
  const payload = { site_id: siteId, ordered_bin_ids: orderedBinIds };
  const response = await axios.post(API_URL + 'order', payload, { headers: authHeader() });
  return response.data;
};

const binService = {
  getAllBins,
  getBinById,
  getBinTelemetry,
  createBin,
  sendCommand,
  setLatch,
  updateBin,
  deleteBin,
  restoreBin,
  updateOrder,
};

export default binService;
